export async function safeFetch<T>(
    promise: any,
    fallbackData: T,
    errorMessage: string = 'Data fetch failed'
): Promise<T> {
    try {
        const { data, error } = await promise;

        if (error) {
            // Silence AbortErrors as they are usually expected due to React StrictMode or navigation
            const isAborted = error.name === 'AbortError' ||
                error.code === '20' ||
                error.message?.toLowerCase().includes('aborted') ||
                error.status === 0;

            if (!isAborted && import.meta.env.DEV) {
                console.error(`${errorMessage}:`, error);
            }
            return fallbackData;
        }

        return data ?? fallbackData;
    } catch (err: any) {
        const isAborted = err.name === 'AbortError' ||
            err.code === '20' ||
            err.message?.toLowerCase().includes('aborted') ||
            err.status === 0;

        if (!isAborted && import.meta.env.DEV) {
            console.error(`${errorMessage} (unexpected):`, err);
        }
        return fallbackData;
    }
}
